import styled from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';
import Slide from '../slide.js';
import Slide_img from '../img/AI_research.png';
import Crow_img_1 from '../img/Crow/1.png';
import Crow_img_2 from '../img/Crow/2.png';

function NIA_AI() {
	return (
		<Wrapper>
			<Slide imgURL={Slide_img} inputText="Example of AI model" />
			<Iwrapper>
				{/* <iframe src="http://210.117.211.209:8081/" width="1200px" height= "1000px"></iframe> */}
				<iframe
					src="http://210.117.211.210:8501/"
					width="1200px"
					height="1000px"
				></iframe>
			</Iwrapper>
			<Crow_img1 src={Crow_img_2} />
			<Crow_img2 src={Crow_img_1} />
		</Wrapper>
	);
}
const Iwrapper = styled.div`
	width: 1200px;
	margin: 100px auto;
`;
const Wrapper = styled.div`
	position: relative;
	top: 70px;
	width: 1200px;
	margin: 0 auto;
`;
const Crow_img1 = styled.img`
	width: 150px;
	height: 86.828px;
	position: absolute;
	top: 320px;
	right: 0px;
`;
const Crow_img2 = styled.img`
	width: 250px;
	height: 249.436px;
	position: absolute;
	top: 70px;
	left: 20px;
`;

export default NIA_AI;
